import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class userStateMissing_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
            <div class="w-site-msg ">
                <div class="site-msg">
                    <strong class="site-msg-title icon i-notice-alert">Your profile is missing a <br>STATE/PROVINCE/REGION</strong>
                    <p class="site-msg-text">This is a required field. Please edit your <a data-bind="attr: {href: userPath() }" rel="noopener noreferrer" target="_blank">profile</a> to add a region.</p>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "userStateMissing_template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            idLoggedInUser: ko.observable(null),
            urlPath: ko.observable('/users/edit/'),
            userPath: ko.observable(""),
        };
    }

    public setIdLoggedInUser(id): void {
        this.getTemplateViewModel().idLoggedInUser(id);
    }
    public getIdLoggedInUser() {
        return this.getTemplateViewModel().idLoggedInUser();
    }

    public setUrlPath(urlPath): void {
        this.getTemplateViewModel().urlPath(urlPath);
    }
    public getUrlPath() {
        return this.getTemplateViewModel().urlPath();
    }
    public buildFullHref() {
        let urlPath = this.getUrlPath();
        let userPath =  urlPath + this.getIdLoggedInUser();

        this.getTemplateViewModel().userPath(userPath);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/userStateMissing_template.ts